import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

import { SENSITIVE_DATA_CLASS } from '@rover/constants/src/platform/sensitiveData.constants';
import { FocusOutline } from '@rover/kibble/styles';

export const Wrapper = styled(({ children, ...props }) => React.cloneElement(children, props))`
  height: 40px;
  width: ${(props) => props.width ?? '100%'};
  background-color: ${({ theme }) => theme.background.primary};
  border-radius: ${({ theme }) => theme.radii.secondary};
  border: ${({ theme }) => theme.borderWidth.primary} solid
    ${(props) =>
      props.haserror === 'true'
        ? `${props.theme.colors.border.error} !important`
        : props.theme.colors.border.primary};
  color: ${({ theme }) => theme.textColor.primary};
  display: block;
  padding: ${({ theme }) => theme.space['2x']};
  transition: border-color ease-in-out 0.15s;

  &:focus {
    ${(props) =>
      props.haserror === 'true'
        ? FocusOutline({ outlineOffset: 0 })
        : FocusOutline({ outlineOffset: 2 })};
  }
  &:focus-within {
    ${(props) =>
      props.haserror === 'true'
        ? FocusOutline({ outlineOffset: 0 })
        : FocusOutline({ outlineOffset: 2 })};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.background.interactive.disabled_base};
    border: 2px solid ${({ theme }) => theme.colors.interactive_border.disabled_base};
    cursor: not-allowed;
    opacity: 1;
  }
`;

type InputRef = any;
// type InputRef = React.RefObject<HTMLInputElement>;

type InputProps = {
  className: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  ref?: InputRef;
};

export type Props = {
  children: (InputProps) => React.ReactNode;
  inputRef?: InputRef;
  onChange?: (value: string) => void;
  sensitive?: boolean;
  hasError?: boolean;
  className?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  placeholder?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  name?: string;
  width?: string;
};

const getClassNames = (sensitive, className) =>
  classNames(className, {
    [SENSITIVE_DATA_CLASS]: sensitive,
  });

const AsInput = ({
  children,
  className = '',
  inputRef,
  onChange,
  sensitive = false,
  hasError,
  width,
}: Props): JSX.Element => {
  const inputProps: InputProps = {
    className: getClassNames(sensitive, className),
    onChange: (event) => onChange && onChange(event.target.value),
    ref: inputRef,
  };

  return (
    <Wrapper className={getClassNames(sensitive, className)} haserror={`${hasError}`} width={width}>
      {children(inputProps)}
    </Wrapper>
  );
};

export default AsInput;
